import React from 'react'
import { H2Blue, UnderlineYellow } from '../../Typography'
import * as S from './styled'
import Cards from './../../3dCard/Cards'
const References = () => {
  return (
    <S.Wrapper className="container">
      <H2Blue>Reference</H2Blue>
      <UnderlineYellow />
      <S.CardsContainer>
        <Cards autoplay={true} autoplay_speed={3000}>
          <S.Card>
            <p>
              „Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.“
            </p>
            <p>
              <S.NameAndPosition>Jan Novák, CEO Google</S.NameAndPosition>
            </p>
          </S.Card>
          <S.Card>
            <p>
              „Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.“
            </p>
            <S.NameAndPosition>Josef Coufal, COO Bosch </S.NameAndPosition>
          </S.Card>
          <S.Card>
            <p>
              „Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.“
            </p>
            <S.NameAndPosition>Adam Dvořák, CMO ČEZ </S.NameAndPosition>
          </S.Card>
        </Cards>
      </S.CardsContainer>
    </S.Wrapper>
  )
}

export default References
